import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStyles } from './SectionWrapper.styles'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import clsx from 'clsx'
import { LabraToolTipV2, ButtonV2 } from '@labrav/react-components'

interface SectionWrapperProps {
  heading: string
  children: JSX.Element
  icon: IconProp
  actionLabel?: string | JSX.Element
  handleAction?: () => void
  className?: string
  actionDisabled?: boolean
  actionDisabledTooltip?: React.ReactNode
  varient?: 'small' | 'medium'
}

export const SectionWrapper = ({
  icon,
  heading,
  children,
  actionLabel,
  handleAction,
  className,
  actionDisabled,
  actionDisabledTooltip,
  varient = 'medium',
}: SectionWrapperProps) => {
  const { classes } = useStyles({ varient })
  return (
    <div
      className={clsx(className ? className : '', classes.root)}
      data-testid={'section-wrapper'}
    >
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <div className={classes.iconContainer}>
            <FontAwesomeIcon
              icon={icon}
              style={{ width: '14px', height: '14px' }}
            />
          </div>
          <div className={classes.headerTextIcon}>
            <div className={classes.heading}>{heading}</div>
          </div>
        </div>
        {actionLabel && handleAction && (
          <LabraToolTipV2
            tooltipPlacement="bottom"
            description={actionDisabledTooltip}
          >
            <ButtonV2
              styleType="link"
              disabled={actionDisabled}
              onClick={handleAction}
            >
              {actionLabel}
            </ButtonV2>
          </LabraToolTipV2>
        )}
      </div>
      {children}
    </div>
  )
}
